export const OrganizationFieldTypeEnum = {
    TEXT: 1,
    RADIO: 2,
    CHECKBOX: 3,
    SELECT: 4,
    NUMBER: 5,
    SELECT_MULTIPLE: 6,
    TEXT_MULTILINE: 7,
    DECIMAL: 8,
    DATE: 9,
    REGEX_TEXT: 10,
    LIKERT: 11,
};

const organizationFieldTypeMessageIds = {
    [OrganizationFieldTypeEnum.TEXT]: "organization.field.type.text",
    [OrganizationFieldTypeEnum.RADIO]: "organization.field.type.radio",
    [OrganizationFieldTypeEnum.CHECKBOX]: "organization.field.type.checkbox",
    [OrganizationFieldTypeEnum.SELECT]: "organization.field.type.select",
    [OrganizationFieldTypeEnum.NUMBER]: "organization.field.type.number",
    [OrganizationFieldTypeEnum.SELECT_MULTIPLE]: "organization.field.type.select.multiple",
    [OrganizationFieldTypeEnum.TEXT_MULTILINE]: "organization.field.type.text.multiline",
    [OrganizationFieldTypeEnum.DECIMAL]: "organization.field.type.decimal",
    [OrganizationFieldTypeEnum.DATE]: "organization.field.type.date",
    [OrganizationFieldTypeEnum.REGEX_TEXT]: "organization.field.type.regex",
    [OrganizationFieldTypeEnum.LIKERT]: "organization.field.type.likert",
};

export const getOrganizationFieldTypeName = (intl, type) => {
    const messageId = organizationFieldTypeMessageIds[type];
    return messageId ? intl.formatMessage({ id: messageId }) : '';
};

// Sem `types`, retorna todos os tipos; com `types`, apenas os informados (ex.: os usados pela organização).
export const getOrganizationFieldTypeOptions = (intl, types = Object.values(OrganizationFieldTypeEnum)) =>
    types
        .filter(type => organizationFieldTypeMessageIds[type])
        .map(type => ({ id: type, name: getOrganizationFieldTypeName(intl, type) }));
